export default variables => ({
  ...variables,
  colorBackground: variables.colorRed,
  colorPrimary: variables.colorMediumGrey,
  colorDarkPrimary: variables.colorBlack,

  textColorPrimary: variables.colorWhite,
});
